import React from "react";
import classes from "./styles.module.scss";

const Textarea = (props) => {

    return (
        <div className={`${classes.textarea} ${props.textAreaStyling}`}>
            <label htmlFor="text_area" {...props}>{props.label}</label>
            <textarea style={props.tstyle} id="text_area" {...props}></textarea>
        </div>
    )
}

export default Textarea;